export function createLabeledMarker(map: google.maps.Map, position: google.maps.LatLngLiteral, svgString: string, labelText: string): google.maps.marker.AdvancedMarkerElement {
    // Wrapper div
    const markerContent = document.createElement('div');
    markerContent.style.position = 'relative';
    markerContent.style.display = 'flex';
    markerContent.style.flexDirection = 'column';
    markerContent.style.alignItems = 'center';

    // ---------- Label ----------
    const label = document.createElement('div');
    label.innerHTML = labelText;
    label.style.background = 'white';
    label.style.color = 'black';
    label.style.fontSize = '12px';
    label.style.fontWeight = 'bold';
    label.style.padding = '2px 6px';
    label.style.borderRadius = '4px';
    label.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
    label.style.position = 'absolute';
    label.style.bottom = '100%';
    label.style.marginBottom = '4px';
    label.style.background = 'rgba(255, 255, 255, 0.8)';
    label.style.color = '#000';
    label.style.backdropFilter = 'blur(4px)';
    label.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
    label.style.borderRadius = '8px';
    label.style.minWidth = '100px';

    // Pointer triangle
    const pointer = document.createElement('div');
    pointer.style.width = '0';
    pointer.style.height = '0';
    pointer.style.borderLeft = '6px solid transparent';
    pointer.style.borderRight = '6px solid transparent';
    pointer.style.borderTop = '6px solid white';
    pointer.style.position = 'absolute';
    pointer.style.bottom = '100%';
    pointer.style.marginBottom = '0px';

    markerContent.appendChild(label);
    markerContent.appendChild(pointer);

    // ---------- SVG Marker ----------
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
    const svgElement = svgDoc.documentElement;
    svgElement.setAttribute('width', '32');
    svgElement.setAttribute('height', '32');

    markerContent.appendChild(svgElement);

    // ---------- Create AdvancedMarkerElement ----------
    const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position,
        content: markerContent,
    });
    marker._ui = {
        markerContent,
    };

    return marker;
}

export function createMarkerNoLabel(map: google.maps.Map, position: google.maps.LatLngLiteral, svgString: string, width: number, height: number): google.maps.marker.AdvancedMarkerElement {
    // Wrapper div
    const markerContent = document.createElement('div');
    markerContent.style.position = 'relative';
    markerContent.style.display = 'flex';
    markerContent.style.flexDirection = 'column';
    markerContent.style.alignItems = 'center';

    // ---------- SVG Marker ----------
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
    const svgElement = svgDoc.documentElement;
    svgElement.setAttribute('width', width.toString());
    svgElement.setAttribute('height', height.toString());

    markerContent.appendChild(svgElement);

    // ---------- Create AdvancedMarkerElement ----------
    const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position,
        content: markerContent,
    });

    return marker;
}

export function buildMarkerSVG(heading: number, colour: string, width = '24', height = '24'): HTMLElement {
    const wrapper = document.createElement('div');

    const svgNS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', width);
    svg.setAttribute('height', height);
    svg.setAttribute('viewBox', '0 0 24 24');

    const arrow = document.createElementNS(svgNS, 'polygon');
    arrow.setAttribute('points', '12,0 24,24 12,18 0,24'); // simple arrow shape
    arrow.setAttribute('fill', colour);
    svg.appendChild(arrow);

    // Rotate
    svg.style.transform = `rotate(${heading}deg)`;

    wrapper.appendChild(svg);
    return wrapper;
}

export function buildArrowMarkerSVG(heading: number, colour: string, width = '24', height = '24'): HTMLElement {
    const wrapper = document.createElement('div');

    const svgNS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', width);
    svg.setAttribute('height', height);
    svg.setAttribute('viewBox', '0 0 24 24');

    const arrow = document.createElementNS(svgNS, 'polygon');
    arrow.setAttribute('points', '12,0 24,24 12,18 0,24'); // simple arrow shape
    arrow.setAttribute('fill', colour);
    svg.appendChild(arrow);

    // Rotate
    svg.style.transform = `rotate(${heading}deg)`;
    svg.style.transformOrigin = '12px 12px';

    wrapper.appendChild(svg);
    return wrapper;
}

export function blinkArrow(wrapper: HTMLElement, duration = 200) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const svg = wrapper.querySelector('svg')!;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const arrow = svg.querySelector('polygon')! as SVGPolygonElement;

    // cancel any existing blink timeout
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((arrow as any)._blinkTimeout) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        clearTimeout((arrow as any)._blinkTimeout);
    }

    // turn blue instantly
    arrow.setAttribute('fill', 'blue');

    // revert to red after `duration` milliseconds
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (arrow as any)._blinkTimeout = setTimeout(() => {
        arrow.setAttribute('fill', 'red');
    }, duration);
}
